module.exports = __webpack_public_path__ + "img/custom-chat.c2dfbbf4.png";